import React, { FunctionComponent, useState } from 'react';
import { LOGOUT } from '../../../constants/messages';
import AxisButton from '../../../components/button/button';
import Text from '../../../components/typography/typgraphy';
import "../error.scss"
import Accordian from '../../../components/accordian/accordian';
import { logoutUser } from '../../../constants/utils';
import { IErrorPageProps } from '../../../constants/commonTypes';

const UpdatePANError: FunctionComponent<IErrorPageProps> = ({ partnerName }) => {
  const [isAccordianExpanded, setIsAccordianExpanded] = useState(false);
  const handleOpenAccordian = () => {
    setIsAccordianExpanded(!isAccordianExpanded)
  }
  return (
    <div className={isAccordianExpanded ? "error-container error-container-1 contained" : "error-container error-container-1"}>
      <div className="error-wrapper">
        <div className="error-description-container">
          <Text className="error-heading">Uh Oh! Your PAN needs updation!</Text>
          <Text className="error-sub-heading-1 desc">Please update your PAN via Insta services</Text>
          <Text className="error-sub-heading-1">Alternatively please visit your nearest Axis Bank Branch and update your PAN.</Text>
          <Accordian expanded={isAccordianExpanded} onClick={handleOpenAccordian} className="accordian" summaryStyle="summary-heading" summary="How to update PAN Card">
            <div className="accordian-container">
              <div className="accordian-item divider">
                <Text className="heading">By SMS or Toll Free number</Text>
                <Text className="sub-heading">Type <b>PAN &lt; Customer ID &gt;</b> and send to <b>5676782</b> from your registered mobile number</Text>
                <Text className="sub-heading">Call <b>1860-419-5555</b> or <b>1860-500-5555</b></Text>
              </div>
              <div className="accordian-item divider">
                <Text className="heading">By Axis Mobile App</Text>
                <div>
                  <div className="step-item">
                    <div className="step">
                      <Text className="step-no">Step 1</Text>
                    </div>
                    <Text className="step-desc">Click on <b>Banking</b></Text>
                  </div>
                  <div className="step-item">
                    <div className="step">
                      <Text className="step-no">Step 2</Text>
                    </div>
                    <Text className="step-desc">Go to Insta Services &gt; Update PAN and upload relevant documents</Text>
                  </div>
                  <div className="step-item">
                    <div className="step">
                      <Text className="step-no">Step 3</Text>
                    </div>
                    <Text className="step-desc">Visit a branch to update your PAN details</Text>
                  </div>
                </div>
              </div>
              <div className="accordian-item divider-1">
                <Text className="heading">By Internet Banking</Text>
                <div>
                  <div className="step-item">
                    <div className="step">
                      <Text className="step-no">Step 1</Text>
                    </div>
                    <Text className="step-desc">Click on <b>Services</b></Text>
                  </div>
                  <div className="step-item">
                    <div className="step">
                      <Text className="step-no">Step 2</Text>
                    </div>
                    <Text className="step-desc">Go to <b>My Profile</b></Text>
                  </div>
                  <div className="step-item">
                    <div className="step">
                      <Text className="step-no">Step 3</Text>
                    </div>
                    <Text className="step-desc">Click on <b>Update Contact Details</b></Text>
                  </div>
                </div>
              </div>
            </div>
          </Accordian>
        </div>
        <div className="logout-container update-account-error">
          <Text className="error-sub-heading-1">After updation, you can restart your journey immediately from {partnerName} to remit. If your case requires additional document verification, you may restart journey after 24 hours. </Text>
          <div className="submit-btn-container">
            <AxisButton onClick={() => logoutUser()} disableElevation customStyle={"submit-btn-primary"} variant="contained">
              <Text className={"submit-btn-text"}>{LOGOUT}</Text>
            </AxisButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdatePANError;
